import { navigate } from 'gatsby';
import React from 'react';

import Icon from '@components/Icon/Icon';

import { BackBtn } from './RecordsBackButton.style';

export default function RecordsBackButton({
  linkTo = '/',
}: {
  linkTo: string;
}) {
  return (
    <BackBtn
      data-testid="records-back-btn"
      onClick={(e) => {
        e.preventDefault();
        if (window.history.length > 1) {
          window.history.back();
        } else {
          navigate(linkTo);
        }
      }}
      to={linkTo}
    >
      <Icon
        clickable
        color="primary.contrastText"
        name="chevron-down"
        rotation={90}
        type="far"
      />
    </BackBtn>
  );
}
